
import { createSelector } from 'reselect';

import { CHAT_STATE, CHAT_LIST_TYPE } from '../../../data/config/constants';

const getAdminId = state => state.admin_details.admin_id;

const getSelectedActiveChatType = state => state.chats_details.selected_active_chat_type

const getSelectedActiveChatPsid = state => state.chats_details.selected_active_chat_id;

const getUntaggedChats = state => state.chats_details.untagged_chats;

const getLiveChats = state => state.chats_details.live_chats;

const getActiveChats = state => state.chats_details.active_chats;

export const getActiveChatItem = createSelector(
  [
    getLiveChats,
    getUntaggedChats,
    getSelectedActiveChatPsid,
    getSelectedActiveChatType
  ],
  (live_chats, untagged_chats, id, type) => (id ? (type === CHAT_LIST_TYPE.UNTAGGED_CHATS ? untagged_chats[id] : live_chats[id]) : null)
);

export const getActiveChatMessages = createSelector(
  [
    getActiveChats,
    getSelectedActiveChatPsid
  ],
  (active_chats, id) => (id && active_chats[id] ? active_chats[id].messages : [])
);

export const getActiveChatSelectedTags = createSelector(
  [
    getActiveChats,
    getSelectedActiveChatPsid
  ],
  (active_chats, id) => (id && active_chats[id] ? active_chats[id].selected_tags : [])
);

export const getActiveChatTags = createSelector(
  [
    getActiveChats,
    getSelectedActiveChatPsid
  ],
  (active_chats, id) => (id && active_chats[id] ? active_chats[id].tags : [])
);

export const getActiveChatTypingInfo = createSelector(
  [
    getActiveChats,
    getSelectedActiveChatPsid
  ],
  (active_chats, id) => (id && active_chats[id] ? active_chats[id].typing_info : {})
);

export const getClientProfileDetails = createSelector(
  [
    getActiveChats,
    getSelectedActiveChatPsid
  ],
  (active_chats, id) => (id && active_chats[id] ? active_chats[id].profile : {})
);

export const getActiveChatSessionId = createSelector(
  getActiveChatItem,
  chat_item => chat_item ? chat_item.sessionId : null
);

export const getUntaggedChatsId = createSelector(
  state => state.chats_details.untagged_chats,
  untagged_chats => Object.keys(untagged_chats)
)

export const makeGetUntaggedChatItem = () => {
  return createSelector(
    [
      (state, props) => props.id,
      state => state.chats_details.untagged_chats,
    ],
    (id, untagged_chats) => untagged_chats[id]
  )
};


export const getLiveChatsGroups = createSelector(
  [getLiveChats, getAdminId],
  (live_chats, admin_id) => {
    let group = {
      pending_chats: [],
      in_queue_chats: [],
      my_chats: [],
      agent_chats: [],
      supervised_chats: [],
      bot_handling_chats: [],
    };
    Object.keys(live_chats).forEach(chatPsid => {
      if (live_chats[chatPsid].chatState === CHAT_STATE.PENDING && live_chats[chatPsid].agentId === admin_id) {
        group.pending_chats.push(chatPsid);
      } else if (live_chats[chatPsid].chatState === CHAT_STATE.IN_QUEUE) {
        group.in_queue_chats.push(chatPsid);
      } else if (live_chats[chatPsid].chatState === CHAT_STATE.AGENT_HANDLING && live_chats[chatPsid].agentId === admin_id) {
        group.my_chats.push(chatPsid);
      } else if (live_chats[chatPsid].chatState === CHAT_STATE.AGENT_HANDLING && live_chats[chatPsid].supervisorId === admin_id) {
        group.supervised_chats.push(chatPsid);
      } else if ((live_chats[chatPsid].chatState === CHAT_STATE.AGENT_HANDLING || live_chats[chatPsid].chatState === CHAT_STATE.PENDING) && live_chats[chatPsid].agentId !== admin_id) {
        group.agent_chats.push(chatPsid);
      } else if (live_chats[chatPsid].chatState === CHAT_STATE.BOT_HANDLING) {
        group.bot_handling_chats.push(chatPsid);
      }
    });
    return group;
  });

export const makeGetChatItem = () => {
  return createSelector(
    [(state, props) => props.psid, getLiveChats],
    (psid, live_chats) => live_chats[psid]
  )
};

export const makeGetChatAccepting = () => {
  return createSelector(
    [
      state => state.chats_details.accepting_chat,
      (state, props) => props.psid
    ],
    (accepting_chat, psid) => accepting_chat === psid
  )
};

export const makeGetChatRejecting = () => {
  return createSelector(
    [
      state => state.chats_details.rejecting_chat,
      (state, props) => props.psid
    ],
    (rejecting_chat, psid) => rejecting_chat === psid
  )
};

export const makeGetChatActiveValue = () => {
  return createSelector(
    [
      state => state.chats_details.selected_active_chat_id,
      (state, props) => (state.chats_details.selected_active_chat_type === CHAT_LIST_TYPE.UNTAGGED_CHATS ? props.id : props.psid)
    ],
    (selected_id, id) => selected_id === id
  )
};

export const makeUnreadMessageCount = () => {
  return createSelector(
    [
      state => state.chats_details.unread_live_message_count,
      (state, props) => props.psid
    ],
    (unread_live_message_count, psid) => unread_live_message_count[psid] ? unread_live_message_count[psid] : 0
  )
};

export const makeGetUnseenStallCount = () => {
  return createSelector(
    [
      state => state.chats_details.unseen_live_chats_stall_count,
      (state, props) => props.psid
    ],
    (unseen_live_chats_stall_count, psid) => unseen_live_chats_stall_count[psid] ? unseen_live_chats_stall_count[psid] : {}
  )
};



// WEBPACK FOOTER //
// ./src/data/redux/chats_details/selectors.js